export default function Router($stateProvider, $urlRouterProvider) {
    "ngInject";

    $urlRouterProvider
        .when("/app/clients", "/app/clients/");

    $stateProvider
        .state({
            name: "clients",
            url: "/app/clients",
            template: "<clients></clients>",
            resolve: {
                $title: () => "Clients | UpReach Cloud"
            }
        })
        .state({
            name: "clients.list",
            url: "/:createdCompany",
            template: "<client-list></client-list>",
            resolve: {
                $title: () => "Clients | UpReach Cloud"
            }
        })
        .state({
            name: "clients.create",
            url: "/create/?:id",
            template: "<client-create></client-create>",
            resolve: {
                $title: () => "Client Create | UpReach Cloud"
            }
        })
        .state({
            name: "clients.settings",
            url: "/settings/:id",
            template: "<client-settings></client-settings>",
            resolve: {
                $title: () => "Client Setting | UpReach Cloud"
            }
        });
}


// WEBPACK FOOTER //
// ./sources/components/clients/clients-router.js